module.exports = __webpack_public_path__ + "static/media/alvin_dp_3.86942528.png";